import { render, staticRenderFns } from "./preview_5.vue?vue&type=template&id=ce48d5de&scoped=true"
import script from "./preview_5.vue?vue&type=script&lang=js"
export * from "./preview_5.vue?vue&type=script&lang=js"
import style0 from "./preview_5.vue?vue&type=style&index=0&id=ce48d5de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce48d5de",
  null
  
)

export default component.exports